// extracted by mini-css-extract-plugin
export default {"wrapper":"vd4laS","logo":"dlj31Q","hidden":"L3JvoM"};